define.alias("shared/components/shared/credentials/tiktok-refresh", "media/components/shared/credentials/tiktok-refresh");